/**
 * @generated SignedSource<<97552bf2fe86d1a47c32ad422f64d80c>>
 * @relayHash b217400b2839c43727d0a9afb0abe9ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f8a1ba401bd1e3c8d4326ced0eb63f131194ae47e29a1e2cf225ea0a1af96fd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedParentQuery } from './decomposedParentQuery.graphql';

import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';

const node: PreloadableConcreteRequest<decomposedParentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8f8a1ba401bd1e3c8d4326ced0eb63f131194ae47e29a1e2cf225ea0a1af96fd",
    "metadata": {},
    "name": "decomposedParentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
